import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//import { fetchTest, fetchTestFilters, clearTest, clearTestQuestion, clearTestFilter } from 'app/actions/TestActions';
import { getOnSiteEvaluations, getIsLoadingOnSiteEvaluationsilters, getOnSiteEvaluationsFilters } from 'app/reducers';
import { Modal, Icon, Tooltip } from 'antd';
import { getEvaluationsFtF, getEvaluationsFiltersFtF, getAsignedEmployeesFtF } from 'app/actions/OnSiteEvaluationsActions';
import { getEmployeesByIdEmployee } from 'app/actions/CommunicationProgramActions';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';

export default function TableContainer(props) {
    const { confirm } = Modal;
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const { siteId } = useSelector(state => state.Auth);
    const { idSubdirection, employeeId } = useSelector(state => state.Auth.employeeById)

    const { classes } = props;
    const columns = [
        {
            title: 'Programa de Comunicación',
            dataIndex: 'communicationProgramName',
            key: 'communicationProgramName',
            sorter: true,
            width: 250
        },{
            title: 'Folio',
            dataIndex: 'courseFolio',
            key: 'courseFolio',
            sorter: true,
            width: 100
        }, {
            title: 'Código',
            dataIndex: 'courseCode',
            key: 'courseCode',
            sorter: true,
            width: 200
        }, {
            title: 'Procedimiento',
            dataIndex: 'courseName',
            key: 'courseName',
            ellipsis: true,
            sorter: true,
            width: 350
        }, {
            title: 'Tipo de Capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            width: 200,
            ellipsis: true
        },
        {
            title: 'Acciones',
            dataIndex: 'idTest',
            key: 'actions',
            fixed: 'right',
            width: 120,
            render: (key, params) => (
                <div className={classes.buttons}>

                    {/* {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(id)} disabled={params.statusName === 'ASIGNADO'}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    } */}

                    <Tooltip placement="bottomLeft" title={'Imprimir'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(params)}>
                            <Icon type="usergroup-add" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showTabEdit = (id, param) => {

        props.setIdTest(id)
        props.setShowModal({
            visible: true,
            idCourse: id.idCourse,
            idDiffusion: id.idDiffusion
        })

        // dispatch(clearTestQuestion());
        // dispatch(clearTestFilter());
        // dispatch(fetchTestFilters(idSubdirection, employeeId));
    }

    let evaluations = useSelector(getOnSiteEvaluations);
    let isLoading = useSelector(getIsLoadingOnSiteEvaluationsilters);
    let testFilter = useSelector(getOnSiteEvaluationsFilters);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(evaluations)) fetchTestAction();
        if (isEmpty(getOnSiteEvaluationsFilters)) fetchTestFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        const obj = {
            SubdirectionId: idSubdirection,
            CourseCode: (props.formData.codeSelected === undefined) ? '' : props.formData.codeSelected,
            CourseName: (props.formData.procedureSelected === undefined) ? '' : props.formData.procedureSelected,
            Trainings: (props.formData.trainingSelected === undefined) ? '' : props.formData.trainingSelected,
            CourseFolio: (props.formData.folioSelected === undefined) ? '' : props.formData.folioSelected,
            sortColumn: column,
            sortDir: order,
            offset: ((pagination.current - 1) * pagination.pageSize),
            limit: pagination.pageSize
        };
        dispatch(getEvaluationsFtF(obj));


    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && evaluations.length > 0) {
            pagination.total = evaluations[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }
    const fetchTestAction = () => dispatch(getEvaluationsFtF({
        offset: offset,
        limit: limit,
        EmployeeId: employeeId,
        SubdirectionId: idSubdirection,
        sortColumn: '',
        sortDir: '',

    }));
    const fetchTestFilterAction = () => dispatch(getEvaluationsFiltersFtF({
        EmployeeId: employeeId,
        SubdirectionId: idSubdirection
    }))
    evaluations.map(item => item['key'] = item.idCommunicationProgram);
    return (props.children({ pagination: pagination, cols: columns, evaluations, testFilter, isLoading, handleTableChange: handleTableChange }));
}